module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_5.ba3e065d.jpg";